import { ReactNode } from "react";
import { colors, type } from "../styles";

const PageHeader = ({
  title,
  subtitle,
  right,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 24,
      marginBottom: 24,
    }}
  >
    <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
      <div style={{ ...type.pageTitle, color: colors.ink }}>{title}</div>
      {subtitle && (
        <div style={{ ...type.bodyRegular, color: colors.inkMuted }}>{subtitle}</div>
      )}
    </div>
    {right && <div style={{ flexShrink: 0 }}>{right}</div>}
  </div>
);

export default PageHeader;
